export const MULTIPLE_CHOICE = 'MultipleChoice';
export const FREE_RESPONSE = 'FreeResponse';
export const INSTRUCTIONS = 'Instructions';
export const TABLE = 'Table';
export const CODE = 'Code';
export const FILE = 'File';

export const QUESTION_TYPES = {
  [MULTIPLE_CHOICE]: true,
  [FREE_RESPONSE]: true,
  [TABLE]: true,
  [CODE]: true,
  [FILE]: true,
};

export const TEXT = 'Text';
export const IMAGE = 'Image';
export const CHOICES_FIELD = 'ChoicesField';
export const RICH_TEXT_FIELD = 'RichTextField';
export const TABLE_FIELD = 'TableField';
export const CODE_FIELD = 'CodeField';
export const FILE_FIELD = 'FileField';

export const RICHFIELD_EMPTY = { text: { ops: [] } };
export const CODEFIELD_EMPTY = {
  code: '',
  pagers: [],
  outputs: [],
  prompts: [],
  executionCount: 0,
};

// Should keep in sync with collaboration/server/sharedbWebsocket.js
export const EXPLORE_PATHS = {
  student: 'studentExplore',
  instructor: 'instructorExplore',
};

export const WORKBOOK_META_FIELDS = [
  'kernelConfig',
  'kernelLanguage',
  'session_key',
  'meta',
  'users',
  'readOnly',
  'locked',
];

// This is only used to denote whether to raise an error banner to the user.
export const CONNECTION_STATUS = {
  ok: 'ok',
  delayed: 'delayed',
  error: 'error',
};
